import { Action, ActionCreator, createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { SingleGraphError } from '../../errors/models/error-message';
import { RegisterOptions } from './register-options';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type QuickFiltersType = any extends RegisterOptions ? RegisterOptions : any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OrderingOptionsType = any extends OrderingOption ? OrderingOption : any;

export type PageEnterActionCreator = ActionCreator<string, () => Action<string>>;
export type PageEnterAction = ReturnType<PageEnterActionCreator>;

export type LoadSuccessProps<TItem> = {
   items: TItem[];
   totalCount: number;
   hasNextPage: boolean;
   endCursor: string | null;
};
export type LoadSuccessActionCreator<TItem> = ActionCreator<
   string,
   (props: LoadSuccessProps<TItem>) => LoadSuccessProps<TItem> & Action<string>
>;

export type LoadSuccessAction<TItem> = ReturnType<LoadSuccessActionCreator<TItem>>;

export type LoadFailureProps = SingleGraphError;
export type LoadFailureActionCreator = ActionCreator<
   string,
   (props: LoadFailureProps) => LoadFailureProps & Action<string>
>;
export type LoadFailureAction = ReturnType<LoadFailureActionCreator>;

export type LoadPageActionCreator = ActionCreator<string, () => Action<string>>;
export type LoadPageAction = ReturnType<LoadPageActionCreator>;

export type LoadPageSuccessProps<TItem> = {
   items: TItem[];
   totalCount: number;
   hasNextPage: boolean;
   endCursor: string | null;
};
export type LoadPageSuccessActionCreator<TItem> = ActionCreator<
   string,
   (props: LoadPageSuccessProps<TItem>) => LoadPageSuccessProps<TItem> & Action<string>
>;
export type LoadPageSuccessAction<TItem> = ReturnType<LoadPageSuccessActionCreator<TItem>>;

export type LoadPageIdSuccessProps = {
   ids: number[] | string[];
};
export type LoadPageIdSuccessActionCreator = ActionCreator<
   string,
   (props: LoadPageIdSuccessProps) => LoadPageIdSuccessProps & Action<string>
>;
export type LoadPageIdSuccessAction = ReturnType<LoadPageIdSuccessActionCreator>;

export type LoadPageFailureProps = SingleGraphError;
export type LoadPageFailureActionCreator = ActionCreator<
   string,
   (props: LoadPageFailureProps) => LoadPageFailureProps & Action<string>
>;
export type LoadPageFailureAction = ReturnType<LoadPageFailureActionCreator>;

export type QuickFilterChangedProps = { quickFilters: QuickFiltersType | null };
export type QuickFilterChangedActionCreator = ActionCreator<
   string,
   (props: QuickFilterChangedProps) => QuickFilterChangedProps & Action<string>
>;
export type QuickFilterchangedAction = ReturnType<QuickFilterChangedActionCreator>;

export type OrderingOptionsChangedProps = {
   orderingOptions: OrderingOptionsType | null;
};
export type OrderingOptionsChangedActionCreator = ActionCreator<
   string,
   (props: OrderingOptionsChangedProps) => OrderingOptionsChangedProps & Action<string>
>;
export type OrderingOptionschangedAction = ReturnType<OrderingOptionsChangedActionCreator>;

export type RegisterActions<TItem> = {
   pageEnter: PageEnterActionCreator;
   loadSuccess: LoadSuccessActionCreator<TItem>;
   loadFailure: LoadFailureActionCreator;
   loadPage: LoadPageActionCreator;
   loadPageSuccess: LoadPageSuccessActionCreator<TItem>;
   loadPageFailure: LoadPageFailureActionCreator;
   quickFilterChanged: QuickFilterChangedActionCreator;
   orderingOptionsChanged: OrderingOptionsChangedActionCreator;
   loadIdPage: LoadPageActionCreator;
   loadIdPageSuccess: LoadPageIdSuccessActionCreator;
   loadIdPageFailure: LoadPageFailureActionCreator;
   clearRegisterFilters: ActionCreator<string, () => Action<string>>;
};

export function createRegisterActions<TItem>(area: string): RegisterActions<TItem> {
   return {
      loadFailure: createAction(`[${area} Register API] Load Failure`, props<LoadFailureProps>()),
      loadPage: createAction(`[${area} Register] Load Page`),
      loadPageFailure: createAction(`[${area} Register API] Load Page Failure`, props<LoadPageFailureProps>()),
      loadPageSuccess: createAction(`[${area} Register API] Load Page Success`, props<LoadPageSuccessProps<TItem>>()),
      loadSuccess: createAction(`[${area} Register API] Load Success`, props<LoadSuccessProps<TItem>>()),
      orderingOptionsChanged: createAction(
         `[${area} Register API] Ordering Options Changed`,
         props<OrderingOptionsChangedProps>()
      ),
      pageEnter: createAction(`[${area} Register] Enter`),
      quickFilterChanged: createAction(`[${area} Register API] Quick Filter Changed`, props<QuickFilterChangedProps>()),
      loadIdPage: createAction(`[${area} Register] Load Id Page`),
      loadIdPageFailure: createAction(`[${area} Register API] Load Id Page Failure`, props<LoadPageFailureProps>()),
      loadIdPageSuccess: createAction(`[${area} Register API] Load Id Page Success`, props<LoadPageIdSuccessProps>()),
      clearRegisterFilters: createAction(`[${area}] Clear Filters`),
   };
}
